import { Config, AuthHeader } from "../helpers/Config";
import { UserService } from "./UserService";

export const ResearchService = {
    /**
     * [RESEARCH] 
     * 
     * @param {string} key Research Key
     */
    Research(key) {

        var requestOptions = {
            method: 'GET',
            headers: AuthHeader()
        }

        return fetch(Config.service.research[key], requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                else if (response.status === 401) {
                    UserService.Logout();
                    window.location.reload();
                }
                else {
                    throw new Error();
                }
            }).then((json) => {
                return json;
            }).catch(function () {
                return false;
            });

    }
}
